import type { ReadConfig } from 'api-read-hook';
import type { HydraCollection } from '../../types';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'ClinicianWeeklyAvailability';
  weekday: number | null;
  windows: Array<{
    '@id': string;
    '@type': 'TimeWindowDto';
    startTime: string;
    endTime: string;
    clinicianWeeklyAvailabilityId: string | null;
  }>;
};

export type W = {
  days: Array<{
    weekday: number | null;
    windows: Array<{
      startTime: string;
      endTime: string;
    }>;
  }>;
};

export function useReadCollectionWeeklyAvailabilities(
  id: string,
  options?: ReadConfig,
) {
  return useApiRead<HydraCollection<V>>(
    `/clinicians/${id}/weekly-availabilities`,
    options,
  );
}
